(function () {
  var DATA = window.RITE_QUIZZES || { hub: {}, quizzes: [] };
  var extra = window.RITE_VALUES_QUIZZES || [];
  DATA.quizzes = extra.concat(DATA.quizzes || []);
  if (!DATA.hub) DATA.hub = {};
  DATA.hub.kicker = DATA.hub.kicker || "RITE Tests";
  DATA.hub.title = "Find out who you are. Then read them.";
  DATA.hub.sub = "A compass, a philosopher match, then the longer values surveys. Each result points at books in the catalog.";
  var ORDER = [
    "political-compass",
    "which-philosopher-are-you",
    "eightvalues",
    "thirdposition",
    "leftvalues",
    "which-dictator-are-you",
    "which-movement-would-have-disliked-you"
  ];
  function sortedQuizzes() {
    var by = {};
    (DATA.quizzes || []).forEach(function (q) { by[q.id] = q; });
    var out = [];
    ORDER.forEach(function (id) { if (by[id]) out.push(by[id]); });
    (DATA.quizzes || []).forEach(function (q) {
      if (ORDER.indexOf(q.id) < 0) out.push(q);
    });
    return out;
  }
  if (!DATA.quizzes.length) return;

  var money = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  var productCache = {};

  function el(html) {
    var d = document.createElement("div");
    d.innerHTML = html.trim();
    return d.firstElementChild;
  }
  function qs(id) {
    for (var i = 0; i < DATA.quizzes.length; i++) if (DATA.quizzes[i].id === id) return DATA.quizzes[i];
    return null;
  }
  function liveQuizzes() {
    return DATA.quizzes.filter(function (q) { return q.status === "live"; });
  }
  function homeQuizzes() {
    var list = sortedQuizzes().filter(function (q) { return q.status === "live"; });
    var preferred = list.filter(function (q) {
      return q.id === "political-compass" || q.id === "which-philosopher-are-you" || q.home;
    });
    var seen = {};
    var out = [];
    preferred.concat(list).forEach(function (q) {
      if (seen[q.id]) return;
      seen[q.id] = 1;
      out.push(q);
    });
    return out.slice(0, 4);
  }
  function utm(handle, quizId) {
    return "/products/" + handle + "?utm_source=quizzes&utm_medium=site&utm_campaign=" + encodeURIComponent(quizId);
  }
  function toast(msg) {
    var t = el('<div class="rq-toast"></div>');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2400);
  }
  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch("/products/" + handle + ".js")
      .then(function (r) { if (!r.ok) throw new Error("missing"); return r.json(); })
      .catch(function () { return null; });
    return productCache[handle];
  }
  function addToCart(variantId) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart");
      document.dispatchEvent(new CustomEvent("cart:update"));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      toast("Added to cart");
    });
  }

  function cardHTML(q, featured) {
    var cls = "rq-card" + (featured ? " is-featured" : "") + (q.status !== "live" ? " is-soon" : "");
    var href = q.status === "live" ? "/pages/" + q.handle : "#";
    return (
      '<a class="' + cls + '" href="' + href + '">' +
        '<div class="rq-card__body">' +
          '<div class="rq-card__meta"><span>' + q.kicker + '</span></div>' +
          "<h3>" + q.title + "</h3>" +
          "<p>" + q.blurb + "</p>" +
          '<span class="rq-card__go">' + (q.status === "live" ? "Take the test →" : "Coming next") + "</span>" +
        "</div>" +
      "</a>"
    );
  }

  var HEAR_OPTS = ["Instagram", "YouTube", "X / Twitter", "Google", "A friend", "Podcast", "Email", "Other"];
  function hearHTML() {
    var saved = "";
    try { saved = localStorage.getItem("rite_heard_about") || ""; } catch (e) {}
    if (saved) {
      return (
        '<div class="rq-hear" id="rq-hear">' +
          "<h3>How did you hear about us?</h3>" +
          '<p class="rq-hear__done">Noted — ' + saved.replace(/</g, "") + ".</p>" +
        "</div>"
      );
    }
    return (
      '<form class="rq-hear" id="rq-hear">' +
        "<h3>How did you hear about us?</h3>" +
        '<p class="rq-hear__sub">Optional. Helps us see what actually sends readers.</p>' +
        '<div class="rq-hear__opts">' +
          HEAR_OPTS.map(function (o) {
            return '<label class="rq-hear__opt"><input type="radio" name="heard" value="' + o + '"> ' + o + "</label>";
          }).join("") +
        "</div>" +
        '<input class="rq-hear__other" name="other" type="text" placeholder="If other, say where" autocomplete="off">' +
        '<button type="submit" class="rq-btn rq-btn--dark">Save</button>' +
      "</form>"
    );
  }
  function bindHear(root) {
    var form = root.querySelector("#rq-hear");
    if (!form || form.tagName !== "FORM") return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var picked = (form.querySelector('input[name="heard"]:checked') || {}).value || "";
      var other = (form.querySelector('input[name="other"]') || {}).value || "";
      other = String(other).trim();
      var val = picked === "Other" && other ? other : (picked || other);
      if (!val) { toast("Pick one"); return; }
      try { localStorage.setItem("rite_heard_about", val); } catch (err) {}
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: { heard_about: val } })
      }).catch(function () {});
      form.outerHTML =
        '<div class="rq-hear" id="rq-hear"><h3>How did you hear about us?</h3>' +
        '<p class="rq-hear__done">Noted — ' + val.replace(/</g, "") + ".</p></div>";
    });
  }

  function renderHub(root) {
    var list = sortedQuizzes();
    var lead = list.slice(0, 2);
    var rest = list.slice(2);
    root.innerHTML =
      '<div class="rq rq-wrap">' +
        '<p class="rq-kicker">' + DATA.hub.kicker + "</p>" +
        '<h1 class="rq-title">' + DATA.hub.title + "</h1>" +
        '<p class="rq-sub">' + DATA.hub.sub + "</p>" +
        '<div class="rq-grid">' +
          lead.map(function (q) { return cardHTML(q, true); }).join("") +
          rest.map(function (q) { return cardHTML(q, false); }).join("") +
        "</div>" +
        hearHTML() +
      "</div>";
    bindHear(root);
  }

  function renderHome(root) {
    var list = homeQuizzes();
    root.innerHTML =
      '<div class="rq rq-home">' +
        '<div class="rq-inner">' +
          '<div class="rq-home__top">' +
            "<h2>Take our <em>tests</em></h2>" +
            '<a class="rq-all" href="/pages/tests">All tests →</a>' +
          "</div>" +
          '<div class="rq-home-row">' +
            list.map(function (q, i) {
              return (
                '<a class="rq-home-card' + (i === 0 ? " is-accent" : "") + '" href="/pages/' + q.handle + '">' +
                  "<span>" + q.kicker.split("·")[0].trim() + "</span>" +
                  "<h3>" + q.title + "</h3>" +
                  "<p>" + q.blurb + "</p>" +
                "</a>"
              );
            }).join("") +
          "</div>" +
        "</div>" +
      "</div>";
  }

  function likertButtons(quiz) {
    return (
      '<div class="rq-choices rq-likert">' +
        quiz.likert.map(function (opt, i) {
          return '<button type="button" class="rq-choice" data-i="' + i + '">' + opt.label + "</button>";
        }).join("") +
      "</div>"
    );
  }
  function choiceButtons(q) {
    return (
      '<div class="rq-choices">' +
        q.choices.map(function (c, i) {
          return '<button type="button" class="rq-choice" data-i="' + i + '">' + c.label + "</button>";
        }).join("") +
      "</div>"
    );
  }

  function compassScore(quiz, answers) {
    var econ = 0, auth = 0, nE = 0, nA = 0;
    quiz.questions.forEach(function (q, i) {
      var likert = quiz.likert[answers[i]];
      if (!likert) return;
      var v = likert.v * q.dir;
      if (q.axis === "econ") { econ += v; nE++; }
      else { auth += v; nA++; }
    });
    var maxE = nE * 2, maxA = nA * 2;
    econ = maxE ? (econ / maxE) * 10 : 0;
    auth = maxA ? (auth / maxA) * 10 : 0;
    var best = quiz.figures[0], bestD = 1e9;
    quiz.figures.forEach(function (f) {
      var d = Math.pow(f.econ - econ, 2) + Math.pow(f.auth - auth, 2);
      if (d < bestD) { bestD = d; best = f; }
    });
    return { econ: econ, auth: auth, figure: best };
  }

  function valuesScore(quiz, answers) {
    var keys = quiz.axes.map(function (a) { return a.id; });
    var sum = {}, max = {};
    keys.forEach(function (k) { sum[k] = 0; max[k] = 0; });
    quiz.questions.forEach(function (q, i) {
      var likert = quiz.likert[answers[i]];
      var mult = likert ? likert.v : 0;
      keys.forEach(function (k) {
        var eff = (q.effect && q.effect[k]) || 0;
        sum[k] += mult * eff;
        max[k] += Math.abs(eff);
      });
    });
    var scores = {};
    keys.forEach(function (k) {
      scores[k] = max[k] ? 100 * (max[k] + sum[k]) / (2 * max[k]) : 50;
    });
    var best = quiz.ideologies[0], bestD = 1e15;
    quiz.ideologies.forEach(function (ideo) {
      var dist = 0;
      keys.forEach(function (k) {
        var diff = Math.abs((ideo.stats[k] || 0) - scores[k]);
        if (quiz.dist === "8values") {
          dist += (k === "dipl" || k === "scty") ? Math.pow(diff, 1.73856063) : Math.pow(diff, 2);
        } else if (quiz.dist === "abs") {
          dist += diff;
        } else {
          dist += diff * diff;
        }
      });
      if (dist < bestD) { bestD = dist; best = ideo; }
    });
    return { scores: scores, figure: best };
  }

  function valuesBarsHTML(quiz, scores) {
    return (
      '<div class="rq-bars">' +
        quiz.axes.map(function (ax) {
          var raw = scores[ax.id];
          if (raw == null) return "";
          var leftPct = ax.invert ? 100 - raw : raw;
          if (isNaN(leftPct)) leftPct = 50;
          var rightPct = 100 - leftPct;
          return (
            '<div class="rq-axisrow">' +
              '<span class="rq-axisrow__l">' + ax.left.label + "</span>" +
              '<div class="rq-barpair">' +
                '<div class="rq-barpair__l" style="width:' + leftPct.toFixed(1) + "%;background:" + ax.left.color + '"><span>' + leftPct.toFixed(0) + "%</span></div>" +
                '<div class="rq-barpair__r" style="width:' + rightPct.toFixed(1) + "%;background:" + ax.right.color + '"><span>' + rightPct.toFixed(0) + "%</span></div>" +
              "</div>" +
              '<span class="rq-axisrow__r">' + ax.right.label + "</span>" +
            "</div>"
          );
        }).join("") +
      "</div>"
    );
  }

  function scoredResult(quiz, answers) {
    var scores = {};
    quiz.questions.forEach(function (q, i) {
      var choice = q.choices[answers[i]];
      if (!choice) return;
      Object.keys(choice.scores).forEach(function (k) {
        scores[k] = (scores[k] || 0) + choice.scores[k];
      });
    });
    var bestId = quiz.results[0].id, bestN = -1;
    Object.keys(scores).forEach(function (k) {
      if (scores[k] > bestN) { bestN = scores[k]; bestId = k; }
    });
    return quiz.results.find(function (r) { return r.id === bestId; }) || quiz.results[0];
  }

  function chartSVG(econ, auth) {
    var x = 110 + econ * 9.2;
    var y = 110 - auth * 9.2;
    x = Math.max(18, Math.min(202, x));
    y = Math.max(18, Math.min(202, y));
    return (
      '<svg class="rq-chart" viewBox="0 0 220 220" aria-hidden="true">' +
        '<rect x="0" y="0" width="110" height="110" fill="rgba(179,18,43,.08)"/>' +
        '<rect x="110" y="0" width="110" height="110" fill="rgba(26,26,26,.08)"/>' +
        '<rect x="0" y="110" width="110" height="110" fill="rgba(201,88,76,.06)"/>' +
        '<rect x="110" y="110" width="110" height="110" fill="rgba(26,26,26,.04)"/>' +
        '<line x1="110" y1="8" x2="110" y2="212" stroke="#1a1a1a" stroke-width="1"/>' +
        '<line x1="8" y1="110" x2="212" y2="110" stroke="#1a1a1a" stroke-width="1"/>' +
        '<text x="110" y="14" text-anchor="middle" font-size="9" fill="#6f6a60">AUTH</text>' +
        '<text x="110" y="216" text-anchor="middle" font-size="9" fill="#6f6a60">LIB</text>' +
        '<text x="10" y="106" font-size="9" fill="#6f6a60">LEFT</text>' +
        '<text x="186" y="106" font-size="9" fill="#6f6a60">RIGHT</text>' +
        '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="7" fill="#b3122b"/>' +
        '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="11" fill="none" stroke="#b3122b" stroke-width="1.5"/>' +
      "</svg>"
    );
  }

  function axisCopy(econ, auth) {
    var e = econ >= 1.2 ? "economic right" : econ <= -1.2 ? "economic left" : "mixed on the economy";
    var a = auth >= 1.2 ? "authoritarian" : auth <= -1.2 ? "libertarian" : "neither a commissar nor an anarchist";
    return (
      "You sit <strong>" + e + "</strong> and <strong>" + a + "</strong> " +
      "(econ " + econ.toFixed(1) + ", authority " + auth.toFixed(1) + " on a −10 to +10 scale). " +
      "Nearest figure in the catalog: the match below."
    );
  }

  function renderBooks(container, handles, quizId) {
    container.innerHTML = "<p class='rq-sub'>Loading titles…</p>";
    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var html = products.map(function (p, i) {
        if (!p) return "";
        var handle = handles[i];
        var img = (p.featured_image || (p.images && p.images[0]) || "").replace(/^\/\//, "https://");
        var v = (p.variants || []).find(function (x) { return x.available; }) || p.variants[0];
        var price = v ? money.format(v.price / 100) : "";
        return (
          '<article class="rq-book">' +
            (img ? '<a href="' + utm(handle, quizId) + '"><img src="' + img + '" alt=""></a>' : "") +
            '<a href="' + utm(handle, quizId) + '"><strong>' + p.title + "</strong></a>" +
            '<div class="rq-book__row"><em>' + price + "</em>" +
              (v ? '<button type="button" class="rq-add" data-vid="' + v.id + '">Add</button>' : "") +
            "</div>" +
          "</article>"
        );
      }).join("");
      container.innerHTML = html || "<p>Titles for this match are being linked up.</p>";
      container.querySelectorAll(".rq-add").forEach(function (btn) {
        btn.addEventListener("click", function () {
          btn.disabled = true;
          addToCart(Number(btn.getAttribute("data-vid"))).catch(function () {
            btn.disabled = false;
            toast("Could not add — try the title page");
          });
        });
      });
    });
  }

  function resultHTML(quiz, payload) {
    var figure = payload.figure;
    var chart = quiz.type === "compass" ? chartSVG(payload.econ, payload.auth) : "";
    var axis = quiz.type === "compass" ? '<p class="rq-axis">' + axisCopy(payload.econ, payload.auth) + "</p>" : "";
    var bars = quiz.type === "values" && payload.scores ? valuesBarsHTML(quiz, payload.scores) : "";
    var years = figure.years ? " · " + figure.years : "";
    var ideology = figure.ideology ? figure.ideology : (quiz.type === "values" ? "Closest match" : "Your match");
    var credit = quiz.credit ? '<p class="rq-credit">' + quiz.credit + "</p>" : "";
    return (
      '<div class="rq-result">' +
        '<p class="rq-result__figure">' + ideology + years + "</p>" +
        "<h2>You are closest to <em>" + figure.name + "</em></h2>" +
        '<p class="rq-result__blurb">' + figure.blurb + "</p>" +
        bars +
        (chart ? '<div class="rq-chart-wrap">' + chart + axis + "</div>" : "") +
        '<div class="rq-books">' +
          "<h3>Read them</h3>" +
          '<div class="rq-books-grid" data-books></div>' +
        "</div>" +
        '<div class="rq-actions">' +
          '<button type="button" class="rq-btn rq-btn--red" data-share>Copy result link</button>' +
          '<button type="button" class="rq-btn rq-btn--dark" data-retry>Retake</button>' +
          '<a class="rq-btn rq-btn--ghost" href="/pages/tests">All tests</a>' +
        "</div>" +
        credit +
        hearHTML() +
      "</div>"
    );
  }

  function renderRunner(root, quizId) {
    var quiz = qs(quizId);
    if (!quiz) {
      root.innerHTML = '<div class="rq rq-wrap"><p>That test is not on this theme yet.</p><p><a href="/pages/tests">Back to tests</a></p></div>';
      return;
    }
    var answers = new Array(quiz.questions.length).fill(null);
    var step = 0;
    var params = new URLSearchParams(window.location.search);
    var preset = params.get("r");

    function showResult(payload) {
      root.querySelector("[data-stage]").innerHTML = resultHTML(quiz, payload);
      var grid = root.querySelector("[data-books]");
      renderBooks(grid, payload.figure.books || [], quiz.id);
      var share = root.querySelector("[data-share]");
      if (share) share.addEventListener("click", function () {
        var url = location.origin + "/pages/" + quiz.handle + "?r=" + encodeURIComponent(payload.figure.id);
        if (payload.scores) {
          url += "&s=" + quiz.axes.map(function (a) { return Number(payload.scores[a.id]).toFixed(1); }).join(",");
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { toast("Link copied"); });
        } else {
          toast(url);
        }
      });
      var retry = root.querySelector("[data-retry]");
      bindHear(root);
      if (retry) retry.addEventListener("click", function () {
        answers = new Array(quiz.questions.length).fill(null);
        step = 0;
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, "", "/pages/" + quiz.handle);
        }
        paint();
      });
    }

    function finish() {
      var payload;
      if (quiz.type === "compass") payload = compassScore(quiz, answers);
      else if (quiz.type === "values") payload = valuesScore(quiz, answers);
      else payload = { figure: scoredResult(quiz, answers) };
      var qs = "?r=" + encodeURIComponent(payload.figure.id);
      if (payload.scores) {
        qs += "&s=" + quiz.axes.map(function (a) { return Number(payload.scores[a.id]).toFixed(1); }).join(",");
      }
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, "", "/pages/" + quiz.handle + qs);
      }
      showResult(payload);
    }

    function paint() {
      var q = quiz.questions[step];
      var pct = Math.round((step / quiz.questions.length) * 100);
      var body =
        '<div class="rq-q">' +
          '<div class="rq-progress"><i style="width:' + pct + '%"></i></div>' +
          '<p class="rq-count">Question ' + (step + 1) + " of " + quiz.questions.length + "</p>" +
          "<h2>" + q.text + "</h2>" +
          (quiz.likert ? likertButtons(quiz) : choiceButtons(q)) +
          '<div class="rq-nav">' +
            '<button type="button" class="rq-btn rq-btn--ghost" data-back' + (step === 0 ? " disabled" : "") + ">Back</button>" +
            '<span></span>' +
          "</div>" +
        "</div>";
      root.querySelector("[data-stage]").innerHTML = body;
      root.querySelectorAll(".rq-choice").forEach(function (btn) {
        if (answers[step] !== null && Number(btn.getAttribute("data-i")) === answers[step]) btn.classList.add("is-on");
        btn.addEventListener("click", function () {
          answers[step] = Number(btn.getAttribute("data-i"));
          if (step < quiz.questions.length - 1) {
            step++;
            paint();
          } else {
            finish();
          }
        });
      });
      var back = root.querySelector("[data-back]");
      if (back) back.addEventListener("click", function () {
        if (step > 0) { step--; paint(); }
      });
    }

    root.innerHTML =
      '<div class="rq rq-wrap">' +
        '<p class="rq-kicker"><a href="/pages/tests">Tests</a> / ' + quiz.kicker + "</p>" +
        '<h1 class="rq-title">' + quiz.title + "</h1>" +
        '<p class="rq-sub">' + quiz.blurb + "</p>" +
        '<div data-stage></div>' +
      "</div>";

    if (preset) {
      var figure;
      if (quiz.type === "compass") figure = (quiz.figures || []).find(function (f) { return f.id === preset; });
      else if (quiz.type === "values") figure = (quiz.ideologies || []).find(function (f) { return f.id === preset; });
      else figure = (quiz.results || []).find(function (f) { return f.id === preset; });
      if (figure) {
        var payload = { figure: figure, econ: figure.econ || 0, auth: figure.auth || 0 };
        if (quiz.type === "values") {
          var vparam = params.get("s") || params.get("v");
          if (vparam && vparam.indexOf(",") !== -1) {
            var parts = vparam.split(",");
            payload.scores = {};
            quiz.axes.forEach(function (ax, i) { payload.scores[ax.id] = parseFloat(parts[i]); });
          } else {
            payload.scores = figure.stats;
          }
        }
        showResult(payload);
        return;
      }
    }
    paint();
  }

  window.RITEQuiz = {
    hub: renderHub,
    home: renderHome,
    runner: renderRunner
  };

  function boot() {
    document.querySelectorAll("[data-rite-quiz]").forEach(function (node) {
      if (node.getAttribute("data-booted")) return;
      node.setAttribute("data-booted", "1");
      var mode = node.getAttribute("data-rite-quiz");
      var id = node.getAttribute("data-quiz-id") || "";
      if (mode === "hub") renderHub(node);
      else if (mode === "home") renderHome(node);
      else if (mode === "runner") renderRunner(node, id);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
